import { Box, Typography, useMediaQuery } from "@mui/material";
import { useEffect, useLayoutEffect, useState } from "react";

import { HORIZONTAL_MAX_ITEM } from "config";
import { Menu } from "menu-items/dashboard";
import { MenuOrientation } from "config";
// project-imports
import NavGroup from "./NavGroup";
// import { get } from "lodash";
import menuItem from "menu-items";
// import useAuth from "hooks/useAuth";
import useConfig from "hooks/useConfig";
import { useSelector } from "store";
// material-ui
import { useTheme } from "@mui/material/styles";

// import adminItems from "menu-items/admin-items";

// ==============================|| DRAWER CONTENT - NAVIGATION ||============================== //

const Navigation = () => {
  // const { user } = useAuth();
  // const userType = get(user, "data[0].useraccount.usertype");
  const theme = useTheme();

  const downLG = useMediaQuery(theme.breakpoints.down("lg"));

  // const userType = chain(user).get("data").map("useraccount.usertype").join("").value();

  const { menuOrientation } = useConfig();
  const { drawerOpen } = useSelector((state) => state.menu);

  const [selectedItems, setSelectedItems] = useState("");
  const [selectedLevel, setSelectedLevel] = useState(0);
  const [menuItems, setMenuItems] = useState({ items: [] });

  useEffect(() => {
    handlerMenuItem();
    // eslint-disable-next-line
  }, []);

  // useLayoutEffect(() => {
  //   if (userType === "CLIENT") {
  //     setMenuItems(adminItems);
  //   } else if (userType === "ADMIN" && userType === "STAFF") {
  //     setMenuItems(adminItems);
  //   }

  //   // eslint-disable-next-line
  // }, [menuItem]);

  // useLayoutEffect(() => {
  //   if (userType === "CLIENT") {
  //     setMenuItems(menuItem);
  //   } else if (userType === "ADMIN" || userType === "STAFF") {
  //     setMenuItems(adminItems);
  //   }
  //}, [menuItem]);

  useLayoutEffect(() => {
    setMenuItems(menuItem);

    // eslint-disable-next-line
  }, [menuItem]);

  let getMenu = Menu();
  const handlerMenuItem = () => {
    const isFound = menuItem.items.some((element) => {
      if (element.id === "group-dashboard") {
        return true;
      }
      return false;
    });

    if (getMenu?.id !== undefined && !isFound) {
      menuItem.items.splice(0, 0, getMenu);
      setMenuItems(menuItem);
    }
  };

  const isHorizontal = menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

  const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
  let lastItemIndex = menuItems.items.length - 1;
  let remItems = [];
  let lastItemId;

  if (lastItem && lastItem < menuItems.items.length) {
    lastItemId = menuItems.items[lastItem - 1].id;
    lastItemIndex = lastItem - 1;
    remItems = menuItems.items.slice(lastItem - 1, menuItems.items.length).map((item) => ({
      title: item.title,
      elements: item.children,
      icon: item.icon
    }));
  }

  const navGroups = menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
    switch (item.type) {
      case "group":
        return (
          <NavGroup
            key={item.id}
            setSelectedItems={setSelectedItems}
            setSelectedLevel={setSelectedLevel}
            selectedLevel={selectedLevel}
            selectedItems={selectedItems}
            lastItem={lastItem}
            remItems={remItems}
            lastItemId={lastItemId}
            item={item}
          />
        );
      default:
        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Fix - Navigation Group
          </Typography>
        );
    }
  });
  return (
    <Box
      sx={{
        pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
        "& > ul:first-of-type": { mt: 0 },
        display: isHorizontal ? { xs: "block", lg: "flex" } : "block"
      }}
    >
      {navGroups}
    </Box>
  );
};

export default Navigation;
